'use client'

import dynamic from 'next/dynamic'
import { type FC, useEffect } from 'react'
import events from '../../constants/analytics'
import useViewPage from '../../shared/hooks/useViewPage'
import { AppDownloadSection, CardProductSection, Header, SocialProof } from './components'
import ProductPageSocialProofSection from '../../shared/components/ProductPageSocialProofSection'
import ProductPageSecondaryBenefitsSection from '../../shared/components/ProductPageSecondaryBenefitsSection'
import TrustPilotScript from '../../shared/components/TrustPilotScript'
import buttons from './components/buttons'

const DynamicProductPageNoRiskSection = dynamic(
  () => import('../../shared/components/ProductPageNoRiskSection')
)

const LandingPage: FC = () => {
  useViewPage(events.EVENTS.INIT.ViewLandingPage)

  useEffect(() => {
    if (window.location.hash === '#credit-cards') {
      const element = document.getElementById('card-product-section')
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }, [])

  return (
    <div className="bg-white col-span-full" data-testid="landing-page">
      <Header />
      <SocialProof />
      <CardProductSection />
      <ProductPageSecondaryBenefitsSection variant="light" />
      <ProductPageSocialProofSection />
      <DynamicProductPageNoRiskSection>{buttons.noRisk}</DynamicProductPageNoRiskSection>
      <AppDownloadSection />
      <TrustPilotScript activate />
    </div>
  )
}

export default LandingPage
